module.exports = __webpack_public_path__ + "background2.jpg?bc062e8c9a89c5f3dbc6d2fd56f72869";